
import {request} from '@/network/request'
export function fetchList(query) {
  return request({
    // url: '/gaoligong/picturevideo/page',
    url: '/gaoligong/picturevideo/getPictureVideoHome',

    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/picturevideo',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/picturevideo/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/picturevideo/' + id,
    method: 'delete'
  })
}
/**
 * 子集列表
 * @param query
 * @returns {AxiosPromise}
 */
export function getChildPictureList(parentId, type,current, size,) {
  return request({
    url: '/gaoligong/picturevideo/getChildPictureList',
    method: 'get',
    params: {
      parentId,
      type,
      current,
      size,
    }
  })
}


export function putObj(obj) {
  return request({
    url: '/gaoligong/picturevideo',
    method: 'put',
    data: obj
  })
}
